import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-lg font-bold text-slate-900 mb-2">{title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/buyer" className="text-blue-600 text-sm font-medium hover:underline" data-testid="privacy-back-link">← Back to Look4Space</Link>
        <h1 className="text-3xl font-bold text-slate-900 mt-4 mb-2">Privacy Policy</h1>
        <p className="text-sm text-slate-500 mb-10">Last updated: June 2026</p>

        <Section title="1. Who We Are">
          <p>Look4Space ("we", "us") operates look4space.com, a platform for discovering and booking spaces — parking, hotels, gyms, coworking, wellness and live video sessions — connecting buyers with space providers (sellers).</p>
        </Section>

        <Section title="2. Information We Collect">
          <p><strong>Account data:</strong> name, email address, password (stored hashed), and role (buyer/seller).</p>
          <p><strong>Listing & booking data:</strong> spaces you list or book, dates, times, services, reviews and messages exchanged on the platform.</p>
          <p><strong>Payment data:</strong> payments are processed by third-party providers (e.g. Stripe). We never store your full card details. Sellers may display their own payment details (e.g. UPI QR codes) which they provide.</p>
          <p><strong>Technical data:</strong> we use cookies for authentication sessions and an anonymous visitor cookie to count unique daily visits. We do not sell this data.</p>
          <p><strong>Location data:</strong> if you use "Near Me" search, your approximate location is used only to find nearby spaces and is not stored.</p>
        </Section>

        <Section title="3. How We Use Your Information">
          <p>To create and manage your account, process bookings and payments, enable chat between buyers and sellers, host live video sessions, send booking notifications, prevent fraud, and improve the platform.</p>
        </Section>

        <Section title="4. Sharing">
          <p>We share your name and booking details with the counterparty of your booking (the seller or buyer). We share payment information with payment processors solely to complete transactions. We do not sell your personal information to third parties.</p>
        </Section>

        <Section title="5. Live Video Sessions">
          <p>Online live sessions use Jitsi Meet. Your display name is shared with session participants. Sessions are not recorded by Look4Space.</p>
        </Section>

        <Section title="6. Data Retention & Your Rights">
          <p>We keep your data while your account is active. You may request access, correction, or deletion of your personal data at any time by contacting us. Deleting your account removes your personal profile data; booking records may be retained where legally required.</p>
        </Section>

        <Section title="7. Security">
          <p>Passwords are stored hashed, authentication uses secure HTTP-only cookies, and all traffic is encrypted with HTTPS.</p>
        </Section>

        <Section title="8. Children">
          <p>Look4Space is not directed at children under 13 and we do not knowingly collect their data.</p>
        </Section>

        <Section title="9. Contact">
          <p>For any privacy questions or requests, contact us at <a href="mailto:support@look4space.com" className="text-blue-600 hover:underline">support@look4space.com</a>.</p>
        </Section>
      </div>
    </div>
  );
}
